import React from 'react';
import Link from 'shared/SlashLink';
import Bg1 from '../../images/shapes/it_solution_hero_bg_1.svg'
import Bg2 from '../../images/hero/it_solution_hero_image_2.webp'
import heroImg from '../../images/hero/buildlab_infrastructure.jpg'
import icon from '../../images/icons/icon_stars_generic.svg'
import logoFortinet from '../../images/clients/buildlab_fortinet.svg'
import logoCisco from '../../images/clients/buildlab_cisco.svg'
import logoMicrosoft from '../../images/clients/buildlab_microsoft.svg'

const Hero = () => {

    return (
        <section className="it_solution_hero_section">
            <div className="container">
                <div className="row">
                    <div className="col-lg-7">
                        <div className="it_solution_hero_content" style={{ backgroundImage: `url(${Bg1})` }}>
                            <div className="heading_focus_text mb-0 d-inline-flex align-items-center"> Welcome to <span className="badge bg-secondary text-white">BUILDLAB</span></div>
                            <h1>
                                California Technology Consulting &amp; Design — for Construction Projects and Business IT
                            </h1>
                            <p>
                                Serving clients across California, we help growing companies and construction projects design, build, and run the technology that powers their operations — from infrastructure to custom software.
                            </p>
                            <ul className="btns_group unordered_list p-0 justify-content-start">
                                <li>
                                    <Link className="btn" to="/pricing">
                                        <span className="btn_label" data-text="Get Started">Get Started</span>
                                        <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right" aria-hidden="true"></i>
                                        </span>
                                    </Link>
                                </li>
                                <li>
                                    <div className="review_short_info">
                                        <div className="d-flex">
                                            <img src={icon} alt="BUILDLAB - Trustpilot Review" />
                                            <span>5.0</span>
                                        </div>
                                        <div className="review_counter">From <b>150+</b> reviews</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <ul className="it_solution_hero_images unordered_list">
                            <li>
                                <img src={heroImg} alt="BUILDLAB - IT Solution - Hero" width="1800" height="1800" fetchpriority="high" />
                            </li>
                            <li>
                                <div className="worldwide_clients">
                                    <div className="counter_value">12+</div>
                                    <p>
                                        Enterprise platforms we design, deploy &amp; manage
                                    </p>
                                    <ul className="unordered_list" style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', margin: 0, padding: 0 }}>
                                        <li>
                                            <img src={logoFortinet} alt="Fortinet" style={{ width: 42, height: 42, borderRadius: 10, background: '#fff', objectFit: 'contain', padding: 6 }} />
                                        </li>
                                        <li>
                                            <img src={logoCisco} alt="Cisco Meraki" style={{ width: 42, height: 42, borderRadius: 10, background: '#fff', objectFit: 'contain', padding: 6 }} />
                                        </li>
                                        <li>
                                            <img src={logoMicrosoft} alt="Microsoft" style={{ width: 42, height: 42, borderRadius: 10, background: '#fff', objectFit: 'contain', padding: 6 }} />
                                        </li>
                                        <li style={{ fontWeight: 700, color: '#fff' }}>
                                            +9 more
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <ul className="categories unordered_list_block">
                                    <li>
                                        <Link to="/service-single/Low-Voltage-and-Structured-Cabling">
                                            <span>Low-Voltage &amp; Cabling</span>
                                            <i className="fa-solid fa-plus" aria-hidden="true"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/it-services">
                                            <i className="fa-solid fa-plus" aria-hidden="true"></i>
                                            <span>Managed IT &amp; Cyber</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/service-single/AI-Business-Integration">
                                            <span>AI Integration</span>
                                            <i className="fa-solid fa-plus" aria-hidden="true"></i>
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <div className="business_growth_content" style={{ backgroundImage: `url(${Bg2})` }}>
                                    <div className="business_growth">
                                        <div className="progress_content">
                                            <svg
                                                role="progressbar"
                                                width="260"
                                                height="260"
                                                viewBox="0 0 100 100"
                                                aria-valuemin="0"
                                                aria-valuemax="100"
                                                aria-valuenow="88"
                                            >
                                                <circle
                                                    cx="50%"
                                                    cy="50%"
                                                    r="42"
                                                    shapeRendering="geometricPrecision"
                                                    fill="none"
                                                    stroke="#f1f1f1"
                                                    strokeWidth="5"
                                                ></circle>
                                                <circle
                                                    cx="50%"
                                                    cy="50%"
                                                    r="42"
                                                    shapeRendering="geometricPrecision"
                                                    className="business_growth-circle-58"
                                                    fill="none"
                                                    strokeWidth="10"
                                                    strokeDashoffset="0"
                                                    strokeDasharray="264"
                                                    strokeLinecap="round"
                                                    style={{ transform: 'rotate(-90deg)', transformOrigin: '50% 50%' }}
                                                    stroke="#fff"
                                                    data-angel="100"
                                                ></circle>
                                                <text
                                                    className="business_growth-text-58"
                                                    x="50%"
                                                    y="50%"
                                                    fill="#fff"
                                                    textAnchor="middle"
                                                    dy="0.35em"
                                                    fontSize="1.6rem"
                                                    fontWeight="400"
                                                >
                                                    <tspan className="business_growth-percent-58">100</tspan>
                                                    <tspan className="business_growth-unit-58">%</tspan>
                                                </text>
                                            </svg>
                                            <p>
                                                One vendor — every low-voltage &amp; IT trade, coordinated.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Hero;